export interface AuraAction {
    type: 'follow_up' | 'alert' | 'recommendation' | 'review';
    description: string;
    priority?: 'high' | 'medium' | 'low';
    executionOwner: 'aura' | 'operation';
    followUpQuestion?: string;
}
